import { ObjectHelper, TypeChecker } from "@ronuse/noseur";

export const Debugger = {

    SECURE_FIELDS: [
        "access_token",
        "session_token",
    ],

    sanitize: (...args: any) => {
        for (let index = 0; index < args.length; index++) {
            if (!TypeChecker.isArray(args[index]) && TypeChecker.isObject(args[index])) {
                args[index] = ObjectHelper.cloneObject(args[index]);
                Object.keys(args[index]).forEach((key) => {
                    if (Debugger.SECURE_FIELDS.includes(key)) {
                        args[index][key] = "<REDACTED>";
                        return;
                    }
                });
            }
        }
        return args;
    },

    log: (...args: any) => console.log("RIVTN.HERA_WEB_CLIENT", ...Debugger.sanitize(...args)),
    warn: (...args: any) => console.warn("RIVTN.HERA_WEB_CLIENT", ...Debugger.sanitize(...args)),
    error: (...args: any) => console.error("RIVTN.HERA_WEB_CLIENT", ...Debugger.sanitize(...args)),

}
